// extracted by mini-css-extract-plugin
export default {"quote":"Quote-module--quote--fa852","citation":"Quote-module--citation--7dd6a","regular":"Quote-module--regular--c1851","bold":"Quote-module--bold--b8fe3"};